angular
    .module(ApplicationConfiguration.applicationModuleName)
    .directive("paginationTable", function () {
        return {
            restrict: "E",
            scope: {
                pagination: "=",
            },
            templateUrl: "/modules/Commom/core/views/pagination.table.html",
            controller: function ($scope) {
            },
        };
    });